import { AttachmentResponse, WebAssetResponse } from "@akitabox/api-client";

import {
  formatDate,
  buildAssetHeader,
  getAssetFieldValue,
  buildAttachmentRows,
} from "./common";

export function imageGridWithDetails(
  attachments: AttachmentResponse[],
  asset: WebAssetResponse
) {
  return (
    <table className="ck-table-resized">
      <colgroup>
        <col style={{ width: "25%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "25%" }} />
      </colgroup>
      <tbody>
        {buildAssetHeader(asset, 4)}
        {buildAttachmentRows(attachments)}
        <tr>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Category:</strong> <i>{asset.pinType.name}</i>
            </span>
          </td>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Size:</strong> <i>{getAssetFieldValue(asset, "Size")}</i>
            </span>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Type:</strong> <i>{getAssetFieldValue(asset, "Type")}</i>
            </span>
          </td>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Installation Date:</strong>{" "}
              <i>
                {getAssetFieldValue(asset, "Installation Date", formatDate)}
              </i>
            </span>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Manufacturer:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Manufacturer")}</i>
            </span>
          </td>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Observed Remaining Life:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Observed Remaining Life")}</i>
            </span>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Model:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Model")}</i>
            </span>
          </td>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Condition:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Condition")}</i>
            </span>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Serial Number:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Serial Number")}</i>
            </span>
          </td>
          <td colSpan={2}>
            <span style={{ fontSize: "12px" }}>
              <strong>Cost:</strong> <i>{asset.cost ? `$${asset.cost}` : ""}</i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
